import script from "./SimpleSelectBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimpleSelectBox.vue?vue&type=script&lang=ts&setup=true"

import "./SimpleSelectBox.vue?vue&type=style&index=0&id=01b90f41&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01b90f41"]])

export default __exports__